import { k as keys } from '../LocalModules/storm-ui-utils/dist/esm/keyboardKeynames-04a50e15-b033061a.js';
import { t as trapTabFocus } from '../LocalModules/storm-ui-utils/dist/esm/focusableElements/trapTabFocus-c2676751-9f3167b4.js';
import { g as getElementFromRef } from '../LocalModules/storm-ui-utils/dist/esm/getElementFromRef-3993f795-83939d54.js';

function useModal(params) {
  const {
    initialRef,
    onClose,
    triggerRef,
    firstRef
  } = params;
  const handleKeyUp = event => {
    if (event.key === keys.ESCAPE) {
      event.preventDefault();
      event.stopPropagation();
      if (onClose) {
        onClose(event);
      }
    }
  };
  const handleKeyDown = event => {
    if (initialRef.current) {
      trapTabFocus(event, initialRef.current);
    }
  };
  const handleFocusOnExit = () => {
    if (triggerRef) {
      const element = getElementFromRef(triggerRef);
      if (element !== null && element !== void 0 && element.focus) {
        element.focus();
      }
    }
  };
  const handleFocusOnEnter = () => {
    if (firstRef) {
      const element = getElementFromRef(firstRef);
      if (element !== null && element !== void 0 && element.focus) {
        element.focus();
      }
    }
  };
  return {
    handleKeyUp,
    handleKeyDown,
    handleFocusOnExit,
    handleFocusOnEnter
  };
}

export { useModal as u };
//# sourceMappingURL=useModalBehaviors-227d4d37.js.map
